module.exports = __webpack_public_path__ + "static/img/091.a92d1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/091.png
// module id = wbAd
// module chunks = 0